module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": _vm.visible,
      "max-width": "760",
      "width": "760",
      "content-class": "premium-dialog"
    },
    on: {
      "input": _vm.onDialogInput
    }
  }, [(_vm.pagamento) ? _c('v-card', {
    staticClass: "pa-0"
  }, [_c('v-toolbar', {
    staticClass: "pt-2",
    attrs: {
      "flat": "",
      "color": "white",
      "dense": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "subheading font-weight-bold grey--text text--darken-2"
  }, [_vm._v("\n        AVALIAR PAGAMENTO\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "grey"
    }
  }, [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-6 pt-2 pb-5"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center mb-4 mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "headline primary--text font-weight-medium"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.pagamento.valor)))]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text mt-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.descricao))])]), _vm._v(" "), _c('span', {
    staticClass: "status-tag mt-2",
    style: ({
      'background-color': _vm.getStatusColor(_vm.pagamento.status)
    })
  }, [_vm._v("\n            " + _vm._s(_vm.formatStatus(_vm.pagamento.status)) + "\n          ")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-4",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    staticClass: "detalhes-box pa-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mb-2",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Vencimento")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_vencimento)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "mb-2 detalhe-direita",
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Solicitado por")]), _vm._v(" "), _c('div', {
    staticClass: "body-2"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamento.solicitante ? _vm.pagamento.solicitante.name : '---'))])])]), _vm._v(" "), (_vm.pagamento.data_pagamento) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text"
  }, [_vm._v("Pago em")]), _vm._v(" "), _c('div', {
    staticClass: "body-2 verde--text text--darken-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.pagamento.data_pagamento)))])])]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pa-3 dialog-actions"
  }, [_c('v-btn', {
    staticClass: "font-weight-bold btn-rejeitar",
    attrs: {
      "flat": "",
      "large": "",
      "color": "red",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.confirmar('rejeitar')
      }
    }
  }, [_vm._v("\n        Rejeitar\n      ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "px-5 font-weight-bold btn-acao-principal btn-autorizar",
    attrs: {
      "dark": "",
      "large": "",
      "color": "secondary",
      "loading": _vm.loading,
      "disabled": _vm.loading
    },
    on: {
      "click": function($event) {
        _vm.confirmar('autorizar')
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("check_circle")]), _vm._v(" Autorizar\n      ")], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-222ec434"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Pagamentos/PagamentosAprovar.vue
// module id = 995
// module chunks = 1